export const DISABLE_USER = 'disable_user';
export const DISABLE_USER_SUCCESSFUL = 'disable_user_successfull';
export const DISABLE_USER_FAILED = 'disable_user_failed';

export const ENABLE_USER = 'enable_user';
export const ENABLE_USER_SUCCESSFUL = 'enable_user_successfull';
export const ENABLE_USER_FAILED = 'enable_user_failed';

